module.exports = __webpack_public_path__ + "img/ddg93-3.64b3779b.png";